import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlueHScroll',
  props: {
  left: Boolean,
},
  setup(__props) {

const props = __props;
const mouseDown = ref(false);
const startX = ref(),
  scrollLeft = ref();
const tabbar = ref();

const startDragging = (e) => {
  mouseDown.value = true;
  startX.value = e.pageX - tabbar.value.offsetLeft;
  scrollLeft.value = tabbar.value.scrollLeft;

  e.preventDefault();
};

const stopDragging = (e) => {
  mouseDown.value = false;
  e.preventDefault();
};

const move = (e) => {
  e.preventDefault();
  if (!mouseDown.value) {
    return;
  }
  const x = e.pageX - tabbar.value.offsetLeft;
  const scroll = x - startX.value;
  tabbar.value.scrollLeft = scrollLeft.value - scroll;
  e.preventDefault();
};

onMounted(() => {
  // Add the event listeners
  tabbar.value.addEventListener("mousemove", move, false);
  tabbar.value.addEventListener("mousedown", startDragging, false);
  tabbar.value.addEventListener("mouseup", stopDragging, false);
  tabbar.value.addEventListener("mouseleave", stopDragging, false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scrollable-div", { left: _ctx.$props.left }]),
    ref_key: "tabbar",
    ref: tabbar
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})